/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --cursor: pointer;
  --border-radius: var(--nve-ref-border-radius-xxl);
  --border-width: var(--nve-ref-border-width-sm);
  --border: var(--border-width) solid transparent;
  --background: var(--nve-sys-interaction-field-background);
  --width: var(--nve-ref-size-1000);
  --height: var(--nve-ref-size-500);
  --padding: 0 var(--nve-ref-size-50);
  --anchor-width: calc(var(--nve-ref-size-300) + var(--nve-ref-size-50));
  --anchor-height: calc(var(--nve-ref-size-300) + var(--nve-ref-size-50));
  --anchor-border-radius: var(--nve-ref-border-radius-xxl);
  --anchor-background: var(--nve-sys-interaction-disabled-color);
  display: inline-block;
  contain: layout;
}

::slotted(input) {
  cursor: var(--cursor) !important;
  appearance: none !important;
  position: absolute !important;
  inset: 0 !important;
  width: var(--width) !important;
  height: var(--height) !important;
  border-radius: var(--border-radius) !important;
  margin: 0 !important;
  padding: 0 !important;
}

[input] {
  align-items: center;
  outline-offset: 2px;
}

[input] slot {
  cursor: var(--cursor);
  border-radius: var(--border-radius);
  border: var(--border);
  background: var(--background);
  height: var(--height);
  width: var(--width);
  padding: var(--padding);
  min-height: auto;
  display: flex !important;
  align-items: center;
  transition: background-color var(--nve-ref-animation-duration-150) ease;
  position: relative;
}

[input] slot::after {
  border-radius: var(--anchor-border-radius);
  background: var(--anchor-background);
  height: var(--anchor-height);
  width: var(--anchor-width);
  display: inline-block;
  content: '';
  transition: transform var(--nve-ref-animation-duration-250) cubic-bezier(0.12, 0.32, 0.54, 2);
  pointer-events: none;
  will-change: transform;
}

:host(:state(checked)) {
  --background: var(--accent-color);
  --anchor-background: var(--nve-sys-text-white-color);
}

:host(:state(checked)) [input] slot::after {
  transform: translate(calc(calc(var(--width) / 2) - var(--border-width)), 0);
}

:host(:state(checked):state(dirty)) [input] slot::after {
  animation: thumb-bounce var(--nve-ref-animation-duration-250) cubic-bezier(0.12, 0.32, 0.54, 2);
}

@keyframes thumb-bounce {
  0% {
    transform: translate(0, 0) scale(1);
  }

  20% {
    transform: translate(calc(var(--width) / 4), 0) scale(1.15);
  }

  60% {
    transform: translate(calc(var(--width) / 1.8), 0) scale(0.95);
  }

  100% {
    transform: translate(calc(var(--width) / 2), 0) scale(1);
  }
}
